export default __webpack_public_path__ + "static/media/us-cnd-icon.b497b7d6.svg";